import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { nodeToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

export class DefinitionListSchemaPlugin extends SchemaPlugin {
  nodes = {
    definition_list: {
      group: 'block',
      content: 'definition_list_item+',
      list: true,
      parseDOM: [{
        tag: 'dl'
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'dl',
      specContent: 'definition_term'
    },

    definition_term: {
      group: 'definition_list_item',
      content: 'mcCentralContainer | block+',
      linkBucket: 'definition_list_item',
      defining: true,
      listItem: true,
      defaultContentToNbsp: true,
      parseDOM: [{
        tag: 'dt'
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'dt',
      specContext: 'definition_list'
    },

    definition_description: {
      group: 'definition_list_item',
      content: 'mcCentralContainer | block+',
      linkBucket: 'definition_list_item',
      defining: true,
      listItem: true,
      defaultContentToNbsp: true,
      parseDOM: [{
        tag: 'dd'
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'dd',
      specContext: 'definition_list'
    }
  } satisfies Record<string, NodeSpec>;
}
